import { Component, input, model, output, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { MedicalHistoryService } from '../../../services/medical-history/medical-history.service';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { MedicalHistoryFormComponent } from '../../forms/medical-history-form/medical-history-form.component';
import { MedicalHistory } from './../../../shared/models/medical-history';
import { NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-medical-history-modal',
  imports: [
    ButtonModule,
    FormsModule,
    ToggleSwitch,
    ModalComponent,
    MedicalHistoryFormComponent,
    NgClass
  ],
  templateUrl: './medical-history-modal.component.html',
  styleUrl: './medical-history-modal.component.scss'
})
export class MedicalHistoryModalComponent {
  @ViewChild(MedicalHistoryFormComponent) medicalHistoryForm!: MedicalHistoryFormComponent;

  readonly isDelete = input<boolean>(false);
  readonly medicalHistory = input<MedicalHistory | null>(null);
  readonly petId = input.required<string>();
  readonly isOpen = model.required<boolean>();
  readonly success = output<MedicalHistory | null>();

  readonly isLoading = signal<boolean>(false);
  readonly isEnabled = signal<boolean>(true);

  constructor(private readonly medicalHistoryService: MedicalHistoryService,
    private readonly messageService: MessageService
  ) {
  }

  onCloseModal(performCreate: boolean = false): void {
    if (this.isLoading()) {
      return;
    }

    this.isOpen.set(false);
  }

  createOrUpdateMedicalHistory(fields: any): void {
    const isUpdate = this.medicalHistory() !== null;

    fields.petId = this.petId();

    let serviceAction;
    if (isUpdate) {
      fields.id = this.medicalHistory()!.id;
      serviceAction = this.medicalHistoryService.updateMedicalHistory(fields);
    } else {
      serviceAction = this.medicalHistoryService.createMedicalHistory(fields);
    }

    serviceAction.subscribe({
      next: (medicalHistory: MedicalHistory) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Registro médico ${isUpdate ? 'atualizado' : 'criado'} com sucesso!`,
          life: 4000
        });

        this.success.emit(medicalHistory);
        this.isLoading.set(false);
        if (!isUpdate) {
          this.medicalHistoryForm.resetForm();
        }
        this.onCloseModal();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: `Falha ao ${isUpdate ? 'atualizar' : 'criar'} registro médico!`,
          life: 4000
        });
        this.isLoading.set(false);
      }
    });
  }

  deleteMedicalHistory(): void {
    this.isLoading.set(true);

    this.medicalHistoryService.deleteMedicalHistory(this.medicalHistory()!.id!)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: () => {
          this.isLoading.set(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Registro médico deletado com sucesso!',
            life: 4000
          });
          this.success.emit(null);
          this.onCloseModal();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao deletar registro médico!',
            life: 4000
          });
        }
      });
  }
}
